import { useQuery } from '@tanstack/react-query';

import { get } from '../../../lib/api';

export const useFetchCampaignsByYear = (year, filter) => {
  const params = {
    year,
    ...(filter && { [filter]: true }),
  };

  const {
    data: {
      campaigns_by_month: campaignsByMonth = {},
      broadcasts_by_month: broadcastsByMonth = {},
      year: responseYear,
    } = {},
    isFetching,
  } = useQuery(
    ['campaigns-by-year', year, filter],
    () => get('/api/client_admin/campaigns/by_year', params),
    {
      refetchOnWindowFocus: false,
      initialData: {
        campaigns_by_month: {},
        broadcasts_by_month: {},
        year,
      },
    },
  );

  return {
    campaignsByMonth,
    broadcastsByMonth,
    year: responseYear,
    isFetching,
  };
};
